module.exports = __webpack_public_path__ + "img/cannery.d5be455c.jpg";